import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorResponse, AWSCognitoErrorResponse, AWSS3ErrorResponse } from '../models/error.model';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

export const HandleHttpError = (httpErrorReponse: HttpErrorResponse): Observable<Error> => {

    console.log("Error happens and details is ---->", httpErrorReponse);

    const errorResponse = new ErrorResponse();

    errorResponse.errorCode = httpErrorReponse.status;

    if (httpErrorReponse.error !== null && httpErrorReponse.error !== undefined) {
      errorResponse.errors = httpErrorReponse.error.Errors;
    }


  if (httpErrorReponse.error !== null && httpErrorReponse.error !== undefined && httpErrorReponse.error.Result) {
        errorResponse.result = httpErrorReponse.error.Result;
    }

    return ErrorObservable.create(errorResponse);
};


export const HandleAWSCognitoError = (awsCognitoError): Observable<ErrorResponse> => {

    //console.log('in HandleAWSCognitoError');
    //console.log(awsCognitoError);
    const errorResponse = new AWSCognitoErrorResponse();

    errorResponse.code = awsCognitoError.code;
    errorResponse.message = awsCognitoError.message;
    errorResponse.name = awsCognitoError.name;

    return ErrorObservable.create(errorResponse);
};

export const HandleAWSS3Error = (awsS3Error): Observable<ErrorResponse> => {

    //console.log('in HandleAWSS3Error');
    //console.log(awsS3Error);
    const errorResponse = new AWSS3ErrorResponse();

    errorResponse.code = awsS3Error.code;
    errorResponse.message = awsS3Error.message;
    errorResponse.name = awsS3Error.name;

    return ErrorObservable.create(errorResponse);
};


